module.exports = __webpack_public_path__ + "img/中国铁建.d97ceaea.png";